module.exports = __webpack_public_path__ + "img/zhiyuanzheicon1.1630993415105.png";